import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { BASE_URL } from "../Config/Config";
import Formatprice from "./Helper/Formatprice";
import { Modal, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { UseGlobellogin } from "./Logincontaxt.jsx/Logincontex";

function OrderHistory() {
  const {userId } = UseGlobellogin();
  const [orderhistory , setorderhistory] = useState([]);
  const [courseOrders, setCourseOrders] = useState([]);  
  // const User_id = localStorage.getItem("user_id");
  const [orderDetails, setOrderDetails] = useState([]); 
  const [ SelectedOrder , setSelectedOrder] = useState({});
  
  const [show , setshow] = useState(false);
    
    const openbillModal = () => setshow(true);
    const closebillModal = () => setshow(false);

   useEffect(() => {
    const orderhistorydata = async () => {
        try {
            // const User_id = localStorage.getItem("user_id");
            const response = await fetch(`${BASE_URL}/courseorder/?user_id=${userId}`);
               const responsedata = await response.json();
              if (response.ok) {
                setorderhistory(responsedata.data);
            } else {
                console.error("Failed profail data:", responsedata.message);
            }
        } catch (error) {
            console.error("Error fetching profail data:", error);
        }
    };
            orderhistorydata(); 
}, []);

  
    const Openorderdetail = async (orderId) => {
      // try {
      //   const response = await fetch(`${BASE_URL}/orderdetail/${id}`);
      //   const data = await response.json();
    
      //   if (response.ok) {
      //     console.log("Fetched order details:", data);
      //     setOrderDetails(data.orderDetails);  
      //     setCourseOrders(data.courseOrders); 
      //        openbillModal(); 
      //   } else {
      //     console.error("Failed to fetch order details:", data.message);
      //   }
      // } catch (error) {
      //   console.error("Error fetching order details:", error);
      // }
   const found = orderhistory.find(item => item.order_id.id === orderId);
     if (found) {
      setSelectedOrder(found.order_id);
      openbillModal();
    }


    };

    const carttotal = SelectedOrder?.cartitems?.reduce((acc, curval) => {
      return acc + curval.total_price;
      }, 0);

     const ordertotal = orderhistory?.reduce((acc , curval)=>{
       return acc + curval.total_price;
     },0);

const uniqueOrders = [];

orderhistory.forEach(order => {
  const existingOrder = uniqueOrders.find(
    o => o.order_id.id === order.order_id.id
  );

  if (existingOrder) {
    // If this order already added, just update total quantity and price
    existingOrder.total_price += Number(order.total_price);
    existingOrder.total_quantity += Number(order.quantity);
  } else {
    // Add new order
    uniqueOrders.push({
      ...order,
      total_price: Number(order.total_price),
      total_quantity: Number(order.quantity)
    });
  }
});


  return (
     <Section>
           <h3>Order History</h3>
      
         <form action="#" className="woocommerce-cart-form">
       <table className="cart_table mb-20">
         <thead>
           <tr>
             <th className="cart-col-image">Order id</th>
             <th className="cart-col-image">Order Date</th>
             <th className="cart-col-productname">Biling name</th>
             <th className="cart-col-quantity"> Total Quantity</th>
             <th className="cart-col-price">Total Amount</th>
           </tr>
         </thead>
   
         {
       uniqueOrders.map((curval , index)=>
         <tbody key={index}>
           <tr className="cart_item" key={index}>
           <td data-title="order_id">
              <strong
  className="product-quantity"
  style={{
    fontWeight: "800",
    cursor: "pointer",
    color: "#007bff",
    textDecoration: "underline", // underline to indicate it's a link
    position: "relative"
  }}
  
  title="Click to view order details" // tooltip on hover
  onClick={() => Openorderdetail(curval?.order_id?.id)}
>
  {curval?.order_id?.id} <i className="fas fa-arrow-right ms-1"></i>
</strong>

             </td>
   
         <td data-title="Date">
  <div className="product-quantity">
    {curval.order_id?.create_date
      ? new Date(curval.order_id.create_date).toLocaleString("en-US", {
          day: "2-digit",
          month: "short", // e.g. Oct
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true, // shows AM/PM
        })
      : "N/A"}
  </div>
</td>

   
             <td data-title="Name">
               <span className="product-quantity" style={{textTransform:"capitalize"}}><span></span>{curval?.order_id?.User_id?.first_name} </span>
             </td>

             <td data-title="Quantity">
               <span className="product-quantity">{curval?.total_quantity}</span>
             </td>
             <td data-title="Total">
               <strong className="product-quantity"><bdi><span></span><Formatprice price={curval?.total_price}/></bdi></strong>
             </td>
           </tr>
         </tbody>
         )}
   
         <tfoot className="checkout-ordertable">
           <tr className="order-total">
             <th style={{fontWeight:"700",fontSize:"1.2rem"}}>Total</th>
             <td data-title="Total" colSpan={5}><strong><span className="woocommerce-Price-amount amount"><bdi><span className="woocommerce-Price-currencySymbol"></span><Formatprice price={ordertotal} /></bdi></span></strong>
             </td>
           </tr>
         </tfoot>
   
       </table>
     </form>

     

<Modal
  show={show}
  onHide={closebillModal}
  centered
  dialogClassName="modal-xl responsive-modal"
>
  <Modal.Header closeButton className="bg-primary text-white">
    <Modal.Title><i className="fas fa-receipt me-2"></i>Order Summary</Modal.Title>
  </Modal.Header>

  <Modal.Body className="bg-light">
    <div className="container-fluid">
      <div className="row gy-4">
        {/* Customer Details */}
        <div className="col-lg-4 col-md-12 col-12">
        <div className="bg-white p-4 rounded-4 shadow h-100 border">
  <h5 className="mb-4 text-primary border-bottom pb-2 d-flex align-items-center">
    <i className="fas fa-user-circle me-2"></i> Customer Details
  </h5>

  <div className="d-flex flex-column gap-3">

    {/* Email Row */}
    <div className="d-flex flex-column p-2 rounded border bg-light">
      <div className="d-flex align-items-center mb-1">
        <i className="fas fa-envelope text-secondary me-2 fs-5"></i>
        <span className="fw-semibold">Billing Name</span>
      </div>
      <span className="text-muted text-break " style={{ wordBreak: "break-all" , textTransform:"capitalize"}}>
        {SelectedOrder?.User_id?.first_name}
      </span>
    </div>

    {/* Email Row */}
    <div className="d-flex flex-column p-2 rounded border bg-light">
      <div className="d-flex align-items-center mb-1">
        <i className="fas fa-envelope text-secondary me-2 fs-5"></i>
        <span className="fw-semibold">Email</span>
      </div>
      <span className="text-muted text-break" style={{ wordBreak: "break-all" }}>
        {SelectedOrder?.User_id?.email}
      </span>
    </div>

    {/* Phone Row */}
    <div className="d-flex flex-column p-2 rounded border bg-light">
      <div className="d-flex align-items-center mb-1">
        <i className="fas fa-phone text-secondary me-2 fs-5"></i>
        <span className="fw-semibold">Phone</span>
      </div>
      <span className="text-muted text-break">
        {SelectedOrder?.User_id?.mobile_no}
      </span>
    </div>

  </div>
      </div>
        </div>


        {/* Order History */}
        <div className="col-lg-8 col-md-12 col-12">
          <div className="bg-white p-4 rounded-4 shadow border">
            <h5 className="mb-4 text-primary border-bottom pb-2">
              <i className="fas fa-box me-2"></i>Ordered Items
            </h5>
            <div className="table-responsive">
              <table className="table table-bordered align-middle table-striped">
                <thead className="table-primary text-center">
                  <tr>
                    <th>Order ID</th>
                    <th>Image</th>
                    <th>Product</th>
                    <th>Price</th>
                    <th>Qty</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {SelectedOrder?.cartitems?.map((curval, index) => (
                    <tr key={index} className="text-center">
                      <td className="fw-bold text-dark">{SelectedOrder.id}</td>
                      <td>
                        <NavLink to="/course">
                          <img
                            src={`${BASE_URL}${curval?.course_img}`}
                            alt="Product"
                            className="img-thumbnail"
                            style={{ height: "70px", width: "70px", objectFit: "contain" }}
                          />
                        </NavLink>
                      </td>
                      <td>{curval?.course_name}</td>
                      <td><Formatprice price={curval?.course_price} /></td>
                      <td>{curval?.quantity}</td>
                      <td><Formatprice price={curval?.total_price} /></td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="fw-bold text-end">
                    <td colSpan={5}>Grand Total:</td>
                    <td className="text-success"><Formatprice price={carttotal} /></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal.Body>

  <Modal.Footer className="bg-white">
    <Button  onClick={closebillModal} className="th-btn style3">
      Close <i className="fas fa-arrow-right ms-2" />
    </Button>
  </Modal.Footer>
</Modal>



         </Section>


  )
}


const Section = styled.section`
  margin: 2.5rem;

  @media (max-width: 768px) {
    margin: 1.5rem;
  }

  .responsive-modal .modal-content {
  border-radius: 12px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
}

.table-hover tbody tr:hover {
  background-color: #f1f1f1;
}

.bg-white {
  background-color: #fff !important;
}
  .modal-xl .modal-content {
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1);
}

.table thead th {
  vertical-align: middle;
}


`;

export default OrderHistory
